import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import useStores from "../../utils/useStores";
import AuthShell from "./AuthShell";

function Login() {
    const rootStore = useStores();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setError("");
        setLoading(true);

        rootStore.profileStore.login(email, password, (success: boolean) => {
            setLoading(false);
            if (success) {
                navigate("/");
            } else {
                setError("Invalid email or password.");
            }
        });
    }

    return (
        <AuthShell eyebrow="Welcome back" title="Sign in" description="Return to your feed and saved corners of Lrner.">
                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="login-email">Email</label>
                        <input
                            id="login-email"
                            type="email"
                            autoComplete="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="login-password">Password</label>
                        <input
                            id="login-password"
                            type="password"
                            autoComplete="current-password"
                            placeholder="Enter Password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && (
                        <p className="auth-error" role="alert">{error}</p>
                    )}

                    <div className="auth-form__meta">
                        <Link to="/forgot-password" className="auth-link">
                            Forgot password?
                        </Link>
                    </div>

                    <div className="auth-form__actions">
                        <button
                            type="submit"
                            disabled={loading}
                            className="auth-button"
                        >
                            {loading ? "Signing in…" : "Sign in"}
                        </button>
                        <Link
                            to="/register"
                            className="auth-button auth-button--secondary"
                        >
                            Create account
                        </Link>
                    </div>
                </form>
        </AuthShell>
    );
}

export default observer(Login);
